import { useState } from "react";
import { SupervisorAgentFiltersPopoverView } from "@/components/organisms/supervisor";
import {
	useSupervisorAgentsFilterStore,
	SupervisorAgentsFilterState,
} from "@/common/stores/nonpersistingStores/supervisorAgentsFilter";
import { getNumberOfFilters } from "@/common/helpers/supervisorHelper";
import { useEffect } from "react";
import { FilterButton } from "@/components/molecules/filterbutton";

export const SupervisorAgentFilter = () => {
	const supervisorAgentsFilterState = useSupervisorAgentsFilterStore(
		(state: SupervisorAgentsFilterState) => state.filterData
	);

	const [filterNumber, setFilterNumber] = useState<number>(
		getNumberOfFilters(supervisorAgentsFilterState)
	);

	useEffect(() => {
		setFilterNumber(getNumberOfFilters(supervisorAgentsFilterState));
	}, [supervisorAgentsFilterState]);

	return (
		<FilterButton
			filterNumber={filterNumber}
			content={<SupervisorAgentFiltersPopoverView />}
		/>
	);
};
